import { InteractionEvent } from '@/helpers/GTM/GTMParameters';
import { trackEventHarmonized } from '@/helpers/GTM/GTMTrack';

export function trackPromoteAccountBannerClick(): void {
  trackEventHarmonized(InteractionEvent.PDP_INTERACTION, {
    h_event_category_006: InteractionEvent.PDP_INTERACTION,
    h_event_action_007: 'goToLogin',
    h_event_label_008: 'banner_pdp',
  });
}
